module.exports = __webpack_public_path__ + "img/classic_1.772edfe8.jpg";